


















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
import EmailFeedbackModal from '../modals/EmailFeedbackModal.vue';

@Component({
    name: 'feedback-invoice-modal',
    components: {
        EmailFeedbackModal
    },
    filters: {
        date(val: any) {
            return val == null ? 'YYYY/MM/DD' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('feedbackInvoices', ['activeFeedbackInvoice', 'activeFeedbackInvoiceLoading']),
        ...mapState('feedbackInvoices', {
            activeFeedbackInvoice: (state: any) => {
                let activeFeedbackInvoice = state.activeFeedbackInvoice;
                // ####### START Formatting cfdi
                switch (activeFeedbackInvoice.invoice_data.cfdi) {
                    case 'G01':
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' - Adquisición de mercancías';
                        break;
                    case 'G03':
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' - Gastos en general';
                        break;
                    case 'I01':
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' - Construcciones';
                        break;
                    case 'I08':
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' - Otra maquinaria y equipo';
                        break;
                    case 'S01':
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' - Sin efectos fiscales';
                        break;
                    default:
                        activeFeedbackInvoice.invoice_data.cfdi = activeFeedbackInvoice.invoice_data.cfdi + ' Checar cfdi';
                        break;
                }
                // ####### END Formatting cfdi

                // ####### START Formatting payment way
                switch (activeFeedbackInvoice.invoice_data.way_payment) {
                    case '01':
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' - Efectivo';
                        break;
                    case '02':
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' - Cheque nominativo';
                        break;
                    case '03':
                        activeFeedbackInvoice.invoice_data.way_payment =
                            activeFeedbackInvoice.invoice_data.way_payment + ' - Transferencia electrónica de fondos';
                        break;
                    case '04':
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' - Tarjeta de crédito';
                        break;
                    case '28':
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' - Tarjeta de débito';
                        break;
                    case '31':
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' - Intermediario pagos';
                        break;
                    default:
                        activeFeedbackInvoice.invoice_data.way_payment = activeFeedbackInvoice.invoice_data.way_payment + ' Checar método de pago';
                        break;
                }
                // ####### END Formatting payment way

                // ####### START Formatting payment method
                switch (activeFeedbackInvoice.invoice_data.payment_method) {
                    case 'PUE':
                        activeFeedbackInvoice.invoice_data.payment_method =
                            activeFeedbackInvoice.invoice_data.payment_method + ' - Pago en una sola exhibición';
                        break;
                    default:
                        activeFeedbackInvoice.invoice_data.payment_method =
                            activeFeedbackInvoice.invoice_data.payment_method + ' Checar método de pago';
                        break;
                }
                // ####### END Formatting payment method

                // ####### START Formatting tax regime
                switch (activeFeedbackInvoice.invoice_data.tax_regime) {
                    case '612':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Personas Físicas con Actividades Empresariales y Profesionales';
                        break;
                    case '616':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Sin obligaciones fiscales';
                        break;
                    case '621':
                        activeFeedbackInvoice.invoice_data.tax_regime = activeFeedbackInvoice.invoice_data.tax_regime + ' - Incorporación Fiscal';
                        break;
                    case '625':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime +
                            ' - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas';
                        break;
                    case '626':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Régimen Simplificado de Confianza';
                        break;
                    case '601':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - General de Ley Personas Morales';
                        break;
                    case '603':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Personas Morales con Fines no Lucrativos';
                        break;
                    case '622':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras';
                        break;
                    case '626':
                        activeFeedbackInvoice.invoice_data.tax_regime =
                            activeFeedbackInvoice.invoice_data.tax_regime + ' - Régimen Simplificado de Confianza';
                        break;
                    default:
                        activeFeedbackInvoice.invoice_data.tax_regime = activeFeedbackInvoice.invoice_data.tax_regime + ' Checar régimen fiscal';
                        break;
                }
                // ####### END Formatting tax regime

                activeFeedbackInvoice.invoice_data.colony = activeFeedbackInvoice.invoice_data.colony
                    ? activeFeedbackInvoice.invoice_data.colony
                    : 'Sin datos';
                activeFeedbackInvoice.invoice_data.phone = activeFeedbackInvoice.invoice_data.phone
                    ? activeFeedbackInvoice.invoice_data.phone
                    : 'Sin datos';
                return activeFeedbackInvoice;
            },
        }),
    },
})
export default class FeedbackInvoiceModal extends Vue {
    public activeFeedbackInvoice!: any;
    public activeFeedbackInvoiceLoading!: any;
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_invoice: any = [];
    public fields_product_invoice: any = ['id', 'qty', 'price'];
    public dateRange: any = {
        date: null,
    };
    singleDatePicker: any = 'range';
    public file_type: any = '';

    errorMessages = {
        'CFDI40148': 'Los datos no coinciden.',
        'CFDI40145': 'Los datos no coinciden.',
        'CFDI40161': 'Datos no válidos.',
        'CFDI40143': 'El RFC no está registrado en el SAT.',
        'CFDI40106': 'El certificado no está firmado por el SAT.',
        'CFDI40999': 'Datos incompletos.',
        'CFDI40149': 'Los datos no coinciden.',
        'El sello del emisor es inválido': 'Los datos no son válidos.',
        'El certificado no está autorizado por el SAT': 'Certificado no autorizado.',
        'El XML no cumple con el estandar del SAT: Falta el atributo Rfc necesario.': 'XML incorrecto.',
        'No se puede resolver el nombre remoto': 'Ha ocurrido un error.',
        'No es posible conectar con el servidor remoto': 'Ha ocurrido un error interno.',
    };

    onGenerateDocs(id: any) {
        this.activeFeedbackInvoice = this.activeFeedbackInvoice;
        this.$bvModal.show('email-feedback-modal');
    }

    simpleMessageError(errorText) {
        for (const [key, message] of Object.entries(this.errorMessages)) {
            if (errorText.includes(key)) {
                return message;
            }
        }
        return 'Error desconocido.';
    }
}
